import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa6daa02"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FA461C",
    d: "M16.463 20h-4.994c-2.493 0-4.521-1.984-4.522-4.424v-.942c0-.414.343-.75.767-.75.423 0 .766.336.766.75v.942c.001 1.612 1.342 2.924 2.989 2.924h4.994c1.653 0 2.998-1.317 2.998-2.935V4.435c0-1.618-1.345-2.934-2.998-2.935H11.48c-1.654 0-3 1.316-3 2.935v.933c0 .414-.343.75-.766.75a.759.759 0 0 1-.767-.75v-.933C6.947 1.99 8.981 0 11.48 0h4.983c2.499.001 4.531 1.991 4.531 4.435v11.13c0 2.446-2.033 4.435-4.531 4.435zM2.627 9.25h10.45c.424 0 .767.336.767.75s-.343.75-.767.75H2.627l1.677 1.635c.3.292.301.766.002 1.06a.769.769 0 0 1-.543.221.773.773 0 0 1-.541-.219L.23 10.531H.229A.76.76 0 0 1 .004 10a.76.76 0 0 1 .225-.531H.23l2.992-2.915a.778.778 0 0 1 1.084.002.738.738 0 0 1-.002 1.06L2.627 9.25z"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
    class: "logout"
  }, [
    _hoisted_1,
    _createTextVNode(" خروج از حساب ")
  ]))
}